<template>
    <div class="stage-empty-state">
        <div class="stage-empty-state-inner">
            <div v-if="icon" class="stage-empty-state-icon-wrap">
                <svg-vue class="stage-empty-state-icon" :icon="icon"></svg-vue>
            </div>
            <div class="stage-empty-state-title">{{ title || $t('No content found') }}</div>
            <div v-if="description" class="stage-empty-state-text">{{ description }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "empty-state",
    props: {
        title: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: 'font-awesome.regular.magnifying-glass'
        }
    }
}
</script>
